import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Label, Input } from "reactstrap";

interface Props {
    isOpen: boolean;
    toggle: () => void;
    representantes?: Array<{ id: number; name: string }>;
    selectedVendedorId?: number;
    onExportPdf: (vendedorId?: number) => void;
    onExportExcel: (vendedorId?: number) => void;
}

export const ExportContratoRelatorioModal: React.FC<Props> = ({
    isOpen,
    toggle,
    representantes = [],
    selectedVendedorId = 0,
    onExportPdf,
    onExportExcel,
}) => {
    const [vendedorId, setVendedorId] = useState<number>(selectedVendedorId);

    useEffect(() => {
        setVendedorId(selectedVendedorId || 0);
    }, [selectedVendedorId, isOpen]);

    const handleExportPdf = () => {
        toggle();
        onExportPdf(vendedorId);
    };

    const handleExportExcel = () => {
        toggle();
        onExportExcel(vendedorId);
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>Exportar relatório de contratos</ModalHeader>
            <ModalBody>
                <p className="text-muted mb-3">
                    Selecione o formato de exportação. Os filtros selecionados na tela serão aplicados.
                </p>
                <FormGroup>
                    <Label className="form-control-label" for="modalRepresentanteComercial">
                        Representante Comercial
                    </Label>
                    <Input
                        className="form-control-alternative"
                        type="select"
                        name="modalRepresentanteComercial"
                        id="modalRepresentanteComercial"
                        value={vendedorId}
                        onChange={(e) => setVendedorId(Number(e.target.value))}
                    >
                        <option value={0}>Todos</option>
                        {representantes.map((rep) => (
                            <option key={rep.id} value={rep.id}>
                                {rep.name}
                            </option>
                        ))}
                    </Input>
                </FormGroup>
            </ModalBody>
            <ModalFooter>
                <Button
                    style={{ color: "#FFF", backgroundColor: "#2dce89" }}
                    type="button"
                    onClick={handleExportExcel}
                >
                    <i className="fa-solid fa-file-excel mr-2"></i>
                    Excel
                </Button>
                <Button color="danger" type="button" onClick={handleExportPdf}>
                    <i className="fa-solid fa-file-pdf mr-2"></i>
                    PDF
                </Button>
                <Button color="secondary" type="button" onClick={toggle}>
                    Cancelar
                </Button>
            </ModalFooter>
        </Modal>
    );
};

